import React, { Component } from "react"
import { Grid, Col, Row } from "react-bootstrap"
import { ExportToCsv } from "export-to-csv"
import ReactTable from "react-table-6"
import Moment from "react-moment"
import moment from "moment"
import Loader from "components/Loader/loader.jsx"
import Button from "components/CustomButton/CustomButton.jsx"
import Card from "components/Card/Card.jsx"
import DayPickerInput from "react-day-picker/DayPickerInput"
import "react-day-picker/lib/style.css"
import { formatDate, parseDate } from "react-day-picker/moment"
import "react-table-6/react-table.css"
import IconImage from "components/Icon/icon.jsx"
import { userService } from 'helpers/user.service.jsx';
const Config = require("config")

class Addresses extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      addressesdatalist: [],
    }

    //  console.log('this.props', this.props)
  }

  componentWillMount() {
    this.getaddresses()
  }

  getaddresses() {
    userService.getinfo().then((data)=>{
    var user = JSON.parse(data)
    var mid = user.data.merchant_id
    var token = user.token
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "access-token": token,
        mid: mid,
      },
    }

    fetch(Config.API + "/api/addresses/", requestOptions)
      .then(this.handleResponse)
      .then((transactiondata) =>
        this.setState({
          addressesdatalist: transactiondata.data,
          loading: false,
        })
      )

  })
  }

  handleResponse(response) {
    return response.text().then((text) => {
      const data = text && JSON.parse(text)

      if (!response.ok) {
        // const error = (data && data.message);
        return "error"
      } else {
        if (data.status == "error") {
          userService.logoutuser()
          return "error"
        }
      }

      return data
    })
  }

  render() {
    function filterCaseInsensitive(filter, row) {
      const id = filter.pivotId || filter.id
      return row[id] !== undefined
        ? isNaN(row[id])
          ? String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
          : String(row[id]).startsWith(filter.value)
        : true
    }

    if (this.state.loading) return <Loader />
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col lg={12}>
              {" "}
              <h3 className="header">Deposit Addresses</h3>
            </Col>



{this.state.addressesdatalist.map((coin, index) => (
   
<div key={index} className="col-md-6">
      <div className="card card-stats">
        <div className="content">
          <div className="row">
            <div className="col-lg-12">
           
              <div className="currency">
              <IconImage size='L' coin={coin.coin} />{coin.coin}
              </div>
            </div>
            <div className="col-lg-12">    
              
                <p className="textwrap">               {coin.address}</p>
          
            </div>
          </div>
        </div>
    
      </div>
   
    </div>
    ))}

    
</Row></Grid>

      </div>
    )
  }
}

export default Addresses
